export default __webpack_public_path__ + "static/media/icn-wtd-max-rpm.e2bd911e.svg";